import actions from './actions'
import state from './state'
import mutations from './mutations'

const coupon = {
  state: state,
  mutations: mutations,
  actions
}

export default coupon



// WEBPACK FOOTER //
// ./src/store/coupon/index.js